import RadioValidationBox from '@sophocles/components/RadioValidationBox/RadioValidationBox';

export default RadioValidationBox;
